export function qkMozartNotifications() {
  return ['mozart-notifications'] as const;
}
